/* eslint-disable */
import React, {Component} from 'react'
import {packages} from './packageFile'
import $ from 'jquery'
import '../../style/shop.css'
import {Link} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

export default class ListAllPackages extends Component {
  constructor() {
    super()
    this.state = {
      msisdn: ''
    }
  }
  componentDidMount() {
    $(function() {
      $('.header').hide()
    })
    let urlParams = new URLSearchParams(window.location.search)
    let msisdn = urlParams.get('msisdn') === null ? '' : urlParams.get('msisdn')
    this.setState({
      msisdn
    })
  }
  goShop = (packId) => {
    if (this.state.msisdn === '') {
      window.location.assign(`/Vitrin/${packId}`)
    } else {
      window.location.assign(`/Vitrin/${packId}?msisdn=${this.state.msisdn}`)
    }
  }

  render() {
    return (
      <div className="position-relative" style={{marginTop: '-80px'}}>
        <div
          style={{width: '100%', minHeight: 50, background: '#f705bc'}}
          className="d-flex d-md-none flex-row align-content-center align-items-center justify-content-center"
        >
          {/*<img src={require('../../image/vitrin.png')} width='30%' height={'auto'}/>*/}
        </div>
        <div className="container">
          <div className="item-wrapper d-flex flex-row justify-content-between flex-wrap">
            {packages.map((item, index) => (
              <div className="card p-2 item flex-nowrap mt-2" onClick={() => this.goShop(item.packId)}>
                <img src={require('../../packagesImage/' + item.packId + '.jpg')} className="img-thumbnail w-100" />
                <Link
                  to={
                    this.state.msisdn !== ''
                      ? `/Vitrin/${item.packId}?msisdn=${this.state.msisdn}`
                      : `/Vitrin/${item.packId}`
                  }
                  className="font-weight-bold text-center mt-2 package-link py-3 text-white"
                >
                  {item.title}
                  <img src={require('../../image/click.svg')} width="35px" className="ml-3" />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}
